import { FC, useMemo } from 'react'

import { Dropdown } from '@revolut-internal/ui-kit'

import { CALENDAR_FILTER_MAX_HEIGHT } from 'components/Filters/consts'
import { NestedDropdownItemBase } from 'components/Filters/NestedDropdownItemBase'
import {
  RangeFilterContent,
  RangeFilterValue,
} from 'components/Filters/RangeFilter/RangeFilterContent'

import { useAdditionalFilters } from '../AdditionalFiltersContext'

type CreationIntervalFilterProps = {
  open: boolean
  onClose: VoidFunction
}

export const CreationIntervalFilter: FC<CreationIntervalFilterProps> = ({
  open,
  onClose,
}) => {
  const { additionalFilters, setAdditionalFilters, removeAdditionalFilters } =
    useAdditionalFilters()

  const dateRange = useMemo(
    () =>
      typeof additionalFilters.from === 'number' &&
      typeof additionalFilters.to === 'number'
        ? {
            timeRange: {
              from: additionalFilters.from,
              to: additionalFilters.to,
            },
          }
        : undefined,
    [additionalFilters.from, additionalFilters.to],
  )

  const handleCustomDateRangeChange = (timeRange: RangeFilterValue | null) => {
    if (timeRange?.timeRange) {
      setAdditionalFilters(timeRange.timeRange)
    } else {
      removeAdditionalFilters(['from', 'to'])
    }

    onClose()
  }

  return (
    <NestedDropdownItemBase
      label="Creation interval"
      renderValue={() => (dateRange ? '1' : '')}
    >
      {(isShown, anchorRef) =>
        isShown && (
          <Dropdown
            open={open}
            anchorRef={anchorRef}
            maxHeight={CALENDAR_FILTER_MAX_HEIGHT}
            onClick={e => e.stopPropagation()}
          >
            <RangeFilterContent
              labelEmptyValue="Select date"
              timeRange={dateRange}
              disabledDays={{ after: new Date() }}
              onSave={handleCustomDateRangeChange}
            />
          </Dropdown>
        )
      }
    </NestedDropdownItemBase>
  )
}
